var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-color-picker__wrapper"},[_c('p',{staticClass:"x-color-picker__title"},[_vm._v("更多颜色")]),_c('el-color-picker',{attrs:{"value":_vm.colorRoot.value},on:{"input":_vm._change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }